import React from "react";
import lastFooter from "./lastFooter.scss";

const LastFooter = () => {
  return (
    <footer className="dark-footer">
      <section className="dark-footer__section">
        <ul>
          <h3>LONDON</h3>
          <li> Fore Street Avenue,</li>
          <li>EC2Y 9DT</li>
          <li>London / United Kingdom </li>
          <li>+44 20 8133 0324</li>
          <li className="link">
            <a href="">Show in Map</a>
          </li>
        </ul>
      </section>
      <section className="dark-footer__section">
        <ul>
          <h3>LISBON</h3>
          <li> Fore Street Avenue,</li>
          <li>EC2Y 9DT</li>
          <li>London / United Kingdom </li>
          <li>+44 20 8133 0324</li>
          <li className="link">
            <a href="">Show in Map</a>
          </li>
        </ul>
      </section>
      <section className="dark-footer__section">
        <ul>
          <h3>ATHENS</h3>
          <li> Fore Street Avenue,</li>
          <li>EC2Y 9DT</li>
          <li>London / United Kingdom </li>
          <li>+44 20 8133 0324</li>
          <li className="link">
            <a href="">Show in Map</a>
          </li>
        </ul>
      </section>
      <section className="dark-footer__section">
        <ul>
          <h3>ISTANBUL</h3>
          <li> Fore Street Avenue,</li>
          <li>EC2Y 9DT</li>
          <li>London / United Kingdom </li>
          <li>+44 20 8133 0324</li>
          <li className="link">
            <a href="">Show in Map</a>
          </li>
        </ul>
      </section>
    </footer>
  );
};

export default LastFooter;
